import React, { Component } from 'react';
import SceButton from "../../../../Common/CommonComponents/sceButton";
import ServiceAccountDetailsComponent from './serviceAccountDetailsComponent';
import overlayClasses from "./sceOverlayStyleDeEnrollConfirmPopup.scss";
import CheckBox from "../../../../Common/CommonComponents/SceCheckBox";
import classes from './PaperlessBillingDeEnrollConfirmPopup.scss';
import SceTextBox from "../../../../Common/TextBox/sceText";
import { getLocalizedStrings } from "./paperlessBillingPopupLocalisedstrings";
import PbErrCard from "./pbErrCard";
import FocusTrap from "focus-trap-react";
export default class extends Component {

    constructor(props) {
        super(props);
        this.strings = getLocalizedStrings("PbTurnOffPopup");
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        let closeIcon;
        this.closeIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Close.svg';
        this.state = {
            turnOff: false,
        };

    }
    turnOffHandler() {
        this.props.submitDeenrollClick();
    }
   componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);        
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }
 
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(event) {
    this.wrapperRef && !this.wrapperRef.contains(event.target) && this.props.isOpen();     
  }
    render() {
        let serviceAccountDetailsJSX;
        serviceAccountDetailsJSX = <ServiceAccountDetailsComponent accountData={this.props.accountData} />;
        return (
            <FocusTrap 
             focusTrapOptions={{
                allowOutsideClick: true,
            }}
            >
            <div>
                <div tabIndex="0" className={[overlayClasses.sceOverlay, classes.sceSetNotificationsDialog].join(' ')}>
                    <div className={overlayClasses.sceOverlayContent}>
                        <div ref={this.setWrapperRef} className={overlayClasses.sceDialogBox}>
                            <div className='row'>
                                <div className={'col-xs-12 ' + classes.sceSetNotificationHeader}>{this.props.yesCancelDeEnroll ? this.strings.OptOutMsg : this.strings.CancelMsg}</div>
                            </div>
                            {serviceAccountDetailsJSX}
                            <div className={["text-align-center", classes.buttonSection].join(' ')}>
                                <div className={classes.cancelBtn}>
                                    <SceButton
                                        id="paperlessBillingCancel"
                                        iconType="cancel"
                                        buttonType="sceCancel"
                                        value={this.strings.CloseButtonValue}
                                        onClick={this.props.closePopup}
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            </FocusTrap>
        );
    }
}
